import { authConstants } from "../_constants";
import { authServices } from "../_services/auth.service";
import { alert } from "../utils/commonFunctions/alert";


export const authActions = {
    userRegister,
    userPreference,
    totalUser,
    merchantRegister,
    merchantPreference,
    totalMerchant,
    influencerRegister,
    totalInfluencer
    // login,
}

function userRegister(data) {
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.REGISTER_USER_REQUEST,
            data: null
        }));
        authServices.userRegister(data)
            .then(
                response => {
                    
                    if (response.status == 200) {
                        dispatch(dispatchFunction({
                            type: authConstants.REGISTER_USER_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.REGISTER_USER_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.REGISTER_USER_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}
function totalUser(data){
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.TOTAL_USER_REQUEST,
            data: null
        }));
        authServices.totalUser(data)
            .then(
                response => {
                    if (response) {
                        dispatch(dispatchFunction({
                            type: authConstants.TOTAL_USER_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.TOTAL_USER_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.TOTAL_USER_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}
function userPreference(data){
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.USER_PREFERENCE_REQUEST,
            data: null
        }));
        authServices.userPreference(data)
            .then(
                response => {
                    if (response.status == 200) {
                        dispatch(dispatchFunction({
                            type: authConstants.USER_PREFERENCE_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.USER_PREFERENCE_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.USER_PREFERENCE_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}

function merchantRegister(data) {
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.REGISTER_MERCHANT_REQUEST,
            data: null
        }));
        authServices.merchantRegister(data)
            .then(
                response => {
                    
                    if (response.status == 200) {
                        dispatch(dispatchFunction({
                            type: authConstants.REGISTER_MERCHANT_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.REGISTER_MERCHANT_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.REGISTER_USER_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}

function merchantPreference(data) {
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.MERCHANT_PREFERENCE_REQUEST,
            data: null
        }));
        authServices.merchantPreferencer(data)
            .then(
                response => {
                    if (response.status == 200) {
                        dispatch(dispatchFunction({
                            type: authConstants.MERCHANT_PREFERENCE_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.MERCHANT_PREFERENCE_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.MERCHANT_PREFERENCE_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}

function totalMerchant(data) {
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.TOTAL_MERCHANT_REQUEST,
            data: null
        }));
        authServices.totalMerchant(data)
            .then(
                response => {
                    if (response) {
                        dispatch(dispatchFunction({
                            type: authConstants.TOTAL_MERCHANT_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.TOTAL_MERCHANT_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.TOTAL_MERCHANT_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}

function influencerRegister(data) {
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.REGISTER_INFLUENCER_REQUEST,
            data: null
        }));
        authServices.influencerRegister(data)
            .then(
                response => {
                    
                    if (response.status == 200) {
                        dispatch(dispatchFunction({
                            type: authConstants.REGISTER_INFLUENCER_SUCCESS,
                            data: response
                        }));
                        alert.success(response.message);
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.REGISTER_INFLUENCER_FAILURE,
                            data: response
                        }));
                        alert.error(response.message);
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.REGISTER_INFLUENCER_FAILURE,
                        data: error.message
                    }));
                    alert.error(error.message);
                }
            );
    };
}

function totalInfluencer(data) {
    return dispatch => {
        dispatch(dispatchFunction({
            type: authConstants.TOTAL_INFLUENCER_REQUEST,
            data: null
        }));
        authServices.totalInfluencer(data)
            .then(
                response => {
                    if (response.status == 200) {
                        dispatch(dispatchFunction({
                            type: authConstants.TOTAL_INFLUENCER_SUCCESS,
                            data: response
                        }));
                    } else {
                        dispatch(dispatchFunction({
                            type: authConstants.TOTAL_INFLUENCER_FAILURE,
                            data: response
                        }));
                    }
                },
                error => {
                    dispatch(dispatchFunction({
                        type: authConstants.TOTAL_INFLUENCER_FAILURE,
                        data: error.message
                    }));
                }
            );
    };
}

// function login(data) {
//     return dispatch => {
//         dispatch(dispatchFunction({
//             type: authConstants.USER_LOGIN_REQUEST,
//             data: null
//         }));
//         authServices.login(data)
//             .then(
//                 response => {
//                     if (response.status == 200) {
//                         dispatch(dispatchFunction({
//                             type: authConstants.USER_LOGIN_SUCCESS,
//                             data: response
//                         }));
//                         alert.success(response.message);
//                     } else {
//                         dispatch(dispatchFunction({
//                             type: authConstants.USER_LOGIN_FAILURE,
//                             data: response
//                         }));
//                         alert.error(response.message);
//                     }
//                 },
//                 error => {
//                     dispatch(dispatchFunction({
//                         type: authConstants.USER_LOGIN_FAILURE,
//                         data: error.message
//                     }));
//                     alert.error(error.message);
//                 }
//             );
//     };
// }

function dispatchFunction(data) {
    // if (data.data && data.data.code === 401) {
    //     return {
    //         type: authConstants.USER_LOGOUT,
    //         data: null
    //     };
    // }
    return {
        type: data.type,
        data: data.data
    };
}